import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingDistinct: false,

  result: [],
};

const appProviderKeyListWDatesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PROVIDER_KEY_LIST_W_DATES_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_PROVIDER_KEY_LIST_W_DATES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_PROVIDER_KEY_LIST_W_DATES_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingDistinct: true,
      };

    case types.GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingDistinct: false,
      };

    case types.GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingDistinct: false,
      };

    

    default:
      return state;
  }
};

export default appProviderKeyListWDatesReducer;
